
import { useState, useEffect } from 'react';

interface PriceDisplayProps {
  counterValue: number;
  showFinalPrice: boolean;
}

const PriceDisplay = ({ counterValue, showFinalPrice }: PriceDisplayProps) => {
  return (
    <div className="text-center relative">
      <div className={`
        transition-all duration-1000 transform-gpu
        ${showFinalPrice ? 'scale-110 rotate-1' : 'scale-100'}
      `}>
        <div className={`
          text-8xl font-black mb-4 relative
          ${showFinalPrice ? 'text-nexx-green animate-pulse' : 'text-nexx-green/80'}
        `}>
          $0
          {showFinalPrice && (
            <div className="absolute inset-0 text-8xl font-black text-nexx-green animate-ping opacity-30" />
          )}
        </div>
        
        <div className={`
          text-xl font-black tracking-widest relative
          ${showFinalPrice ? 'text-nexx-green' : 'text-nexx-green/80'}
        `}>
          AT NO EXTRA COST
          {showFinalPrice && (
            <div className="absolute -inset-2 bg-nexx-green/20 rounded-lg blur-sm" />
          )}
        </div>

        {/* Fine print below */}
        <div className="text-xs text-gray-400 mt-3 opacity-70">
          (Competitors charge ${counterValue > 0 ? counterValue : '299+'})
        </div>
      </div>

      {/* Burst Effect */}
      {showFinalPrice && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-8 bg-gradient-to-t from-nexx-green to-transparent animate-burst"
              style={{
                left: '50%',
                top: '50%',
                transformOrigin: 'bottom',
                transform: `rotate(${i * 30}deg) translateY(-40px)`,
                animationDelay: `${i * 0.1}s`
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PriceDisplay;
